import {
  ColorSchemeProvider,
  LanguageProvider,
  OptimizationUtils,
} from "@crescentapplications/react-ui";
import "@crescentapplications/react-ui/dist/main.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";

try {
  OptimizationUtils.windowControlsOverlay();
} catch {
  // Window Controls Overlay API not available on this platform (e.g. iOS WKWebView)
}

const rootElement = document.getElementById("root");

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <ColorSchemeProvider>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </ColorSchemeProvider>
    </StrictMode>,
  );
} else {
  throw new Error('Root element with id "root" not found');
}
